import { useEffect, useRef } from 'react';

const LightSpots = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Create random light spots
    const spots = [];
    for (let i = 0; i < 20; i++) {
      const spot = document.createElement('div');
      spot.className = 'light-spot';
      spot.style.left = `${Math.random() * 100}%`;
      spot.style.top = `${Math.random() * 100}%`;
      spot.style.animationDelay = `${Math.random() * 3}s`;
      container.appendChild(spot);
      spots.push(spot);
    }

    return () => {
      spots.forEach(spot => spot.remove());
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="fixed inset-0 pointer-events-none z-0"
      aria-hidden="true"
    />
  );
};

export default LightSpots;